import { render } from "./ManagerPlaceHolder.vue?vue&type=template&id=f8a28026"
import script from "./ManagerPlaceHolder.vue?vue&type=script&lang=js"
export * from "./ManagerPlaceHolder.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__